import { reportError } from "./report-error";

let installed = false;

export function setupGlobalErrorHandlers(): void {
  if (installed) return;
  if (typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event: ErrorEvent) => {
    reportError({
      error: event.error ?? event.message ?? "Unknown error",
      source: "window",
    });
  });

  window.addEventListener(
    "unhandledrejection",
    (event: PromiseRejectionEvent) => {
      reportError({
        error: event.reason ?? "Unhandled rejection",
        source: "unhandledrejection",
      });
    },
  );
}

export function __resetSetupForTest(): void {
  installed = false;
}
